module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5804a535f24c1b832b4a0602eeded176.png";